module.exports = __webpack_public_path__ + "static/no_permission.bd1fddd7.png";